import { CommunicationModuleState } from "../store/CommunicationModuleState";

/**
 * The Communication Module Redux Reducer
 * @param state The IApplicationState for this reducer
 * @param action Standard Redux action payload of a type and payload 
 */
export function communicationReducer(state: CommunicationModuleState = new CommunicationModuleState(), action: IReduxAction) {
    switch (action.type) { 
        default:
            return state;
    }
}
